import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_2747571539 from "../../../../../packages/component/src/components/collapse/demo/demo1.js?loadDemo";
import legacyImportDemo_2651955792 from "../../../../../packages/component/src/components/collapse/demo/demo2.js?loadDemo";
import legacyImportDemo_1813394385 from "../../../../../packages/component/src/components/collapse/demo/demo3.js?loadDemo";
import legacyImportDemo_3555624406 from "../../../../../packages/component/src/components/collapse/demo/demo4.js?loadDemo";
import legacyImportDemo_1046815575 from "../../../../../packages/component/src/components/collapse/demo/demo5.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_2747571539,
  legacyImportDemo_2651955792,
  legacyImportDemo_1813394385,
  legacyImportDemo_3555624406,
  legacyImportDemo_1046815575,
  React
};